import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Shield, Award, Languages } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 150]);
  const trustSignals = [{
    icon: Shield,
    text: 'Licensed & Insured'
  }, {
    icon: Languages,
    text: 'Bilingual Service (EN/ES)'
  }, {
    icon: Award,
    text: 'Serving Phoenix Valley Since Day One'
  }];
  return <section className="relative h-screen min-h-[600px] w-full overflow-hidden" data-id="element-53">
      <motion.div style={{
      y
    }} className="absolute inset-0 w-full h-full" data-id="element-54">
        <img src="https://cdn.magicpatterns.com/uploads/uEAYxpAAZfpCj6kf2csgWB/manuel-torres-garcia-QvZ2bnXihRQ-unsplash.jpg" alt="Arborist trimming a palm tree at sunset" className="w-full h-full object-cover" data-id="element-55" />
        <div className="absolute inset-0" style={{
        backgroundColor: 'rgba(0,0,0,0.80)'
      }} data-id="element-56" />
      </motion.div>

      <div className="relative z-10 h-full flex items-center justify-center" data-id="element-57">
        <div className="container mx-auto px-6 text-center" data-id="element-58">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/x1GHF6NPVyfoAJS1XwbkQu/phoenix-tree-experts.png" alt="Phoenix Tree Experts" className="w-20 h-20 mx-auto mb-6" data-id="element-60" />
            <h1 className="font-display text-4xl md:text-6xl lg:text-7xl text-white font-bold mb-6 leading-tight" style={{
            textShadow: '0 2px 12px rgba(0,0,0,0.9)'
          }} data-id="element-61">
              Phoenix Valley's Trusted Tree Experts
            </h1>
            <p className="font-body text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-8 leading-relaxed" style={{
            textShadow: '0 1px 8px rgba(0,0,0,0.85)'
          }} data-id="element-62">
              Tree pruning, removal, and storm prep, done right, done safely, by
              a bilingual crew you can trust.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12" data-id="element-63">
              <Button className="bg-brand-orange hover:bg-brand-orange/90 text-white font-body font-semibold h-12 md:h-14 px-8 w-full sm:w-auto min-h-[48px]" data-id="element-64">
                Get a Free Quote
              </Button>
              <Button variant="outline" className="bg-black/40 border-2 border-white text-white hover:bg-white hover:text-brand-bg font-body font-semibold h-12 md:h-14 px-8 w-full sm:w-auto min-h-[48px]" data-id="element-65">
                Call Rigo Now, 602-552-5252
              </Button>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center text-white/90" data-id="element-66">
              {trustSignals.map((signal, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2 + index * 0.1
            }} className="flex items-center gap-2 font-body text-sm md:text-base" data-id="element-67">
                  <signal.icon className="w-5 h-5 text-brand-green" data-id="element-68" />
                  <span data-id="element-69">{signal.text}</span>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}